<template>
  <div class="px-8 mb-16 w-full lg:w-1/2">
    <div class="coupon-available__coupon-tickets__coupon border-1 border-grey-light h-full p-16 rounded" :class="{'shadow-lg': isShadow, 'disable': isDisable}">
      <div
        class="coupon-available__coupon-tickets__coupon__head border-b-1 border-grey-light flex items-start justify-between pb-16">
        <h6 class="text-base font-bold">
          <template>{{ coupon.name }}</template>
        </h6>
        <label class="leading-normal font-bold text-blue-light flex-no-shrink ml-16">
          <!-- <span v-if="coupon.discountUnit === 'price'">
            $ {{ coupon.discountValue | toCurrency }} <small>{{ coupon.currency }}</small>
          </span>
          <span v-if="coupon.discountUnit === 'percent'">
            {{ coupon.discountValue | toPercentage }}%
          </span> -->
          {{ displayCouponCount(coupon) }}
        </label>
      </div>
      <div class="coupon-available__coupon-tickets__coupon__body flex items-start sm:items-end justify-between text-sm pt-16">
        <div class="coupon-available__coupon-tickets__coupon__body__content">
          <p v-if="coupon.platform === COUPON_PLATFORM_APP" class="flex items-center font-bold text-blue-light">
            <img class="mr-8" height="24px" width="24px" src="@/assets/images/icon-app-only.svg" />
            {{ $t('usedForApp') }}
          </p>
          <p v-if="coupon.status === COUPON_STATUS_VALID && coupon.description" class="mb-16 mt-8">{{ coupon.description }}</p>
          <span class="text-grey-dark leading-normal">
            <template v-if="coupon.status === COUPON_STATUS_EXPIRED">{{ $t('expiredCoupon') }}：{{ coupon.expiryAt | toDate('YYYY-MM-DD HH:mm:ss') }}</template>
            <template v-else-if="coupon.status === COUPON_STATUS_INVALID">{{ $t('invalidCoupon') }}</template>
            <template v-else-if="coupon.status === COUPON_STATUS_USED">{{ $t('usedCoupon') }}：{{ coupon.updatedAt | toDate('YYYY-MM-DD HH:mm:ss') }}</template>
            <template v-else>{{ $t('expiredDate') }}：{{ coupon.expiryAt | toDate('YYYY-MM-DD HH:mm:ss') }}</template>
          </span>
        </div>
        <button v-if="coupon.status === COUPON_STATUS_VALID" class="btn btn-text btn-grey-dark p-0 -mr-8 flex-no-shrink mt-16 sm:mt-0" @click="showCouponModal(coupon)">
          <i class="owl-direction-right text-grey-dark"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import fullPageModal from '@/components/modals/fullPageModal'
import couponDetail from '@/components/couponDetail'

const COUPON_STATUS_VALID = 'canUse'
const COUPON_STATUS_EXPIRED = 'expired'
const COUPON_STATUS_INVALID = 'invalid'
const COUPON_STATUS_USED = 'used'

const COUPON_PLATFORM_APP = 'app'

export default {
  name: 'CouponCard',
  props: {
    coupon: {
      type: Object,
      required: true
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    isShadow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      COUPON_PLATFORM_APP,
      COUPON_STATUS_VALID,
      COUPON_STATUS_EXPIRED,
      COUPON_STATUS_INVALID,
      COUPON_STATUS_USED
    }
  },
  filters: {
    toPercentage: function (val) {
      return 100 - val * 100
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency'
    }),
    isCurrencyConvert: function () {
      return this.coupon.currency !== this.selectedCurrency
    }
  },
  methods: {
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
        if (this.isCurrencyConvert) {
          return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency })
        } else {
          return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency }))
        }
      }
    },
    showCouponModal (coupon) {
      this.$modal.show(fullPageModal,
        {
          // 輸入內容
          context: couponDetail,
          data: {
            coupon
          }
        },
        {
          adaptive: true,
          name: 'couponDetail',
          clickToClose: true,
          height: 'auto',
          width: '95%',
          minWidth: 350,
          maxWidth: 600,
          scrollable: true
        }
      )
    }
  }
}
</script>

<style lang="sass" scoped>
.coupon-available
  &__coupon-tickets
    &__coupon
      &:hover:not(.disable)
        @apply shadow
      &.disable
        opacity: .6
</style>
